import { render, staticRenderFns } from "./CardOrderHistory.vue?vue&type=template&id=2abcd0e0&"
import script from "./CardOrderHistory.vue?vue&type=script&lang=js&"
export * from "./CardOrderHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports